import logo from "../assets/logo-2.png";
import approved from "../assets/gar.png";
import paid from "../assets/paid.png";
import red from "../assets/red.png";
import { useEffect } from "react";
import useParcelStore from "../stores/parcelStore";
import moment from "moment";
import Parcel from "./Parcel";

const Invoice = () => {
  const parcel = useParcelStore((state) => state.parcel);

  const handlePrint = () => {
    window.print();
  };

  const subTotal = Number(parcel?.parcelWeight) * 22;
  const insurance = (3 * subTotal) / 100;
  const tariff = (2.1 * subTotal) / 100;
  const tax = (17 * subTotal) / 100;
  const declaredTax = (Number(parcel?.parcelValue) * 15) / 100;
  const fee = subTotal + insurance + tariff + tax + declaredTax;

  // ---------------------------------

  const tableStyles = {
    border: "1px solid #ccc",
    width: "100%",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    borderCollapse: "collapse",
    textAlign: "left",
  };

  const headerStyles = {
    backgroundColor: "#69707A",
    color: "#ffffff",
    padding: "8px",
    border: "1px solid #ccc",
  };

  const cellStyles = {
    padding: "8px",
    border: "1px solid #ccc",
  };

  const footerRowStyles = {
    fontWeight: "bold",
  };

  return (
    <>
      <div className="invoiceWrapper">
        {/* -------- Stickers ---------------- */}
        <img
          src={approved}
          alt="Approved"
          id="approveImg"
          style={{
            display: "block",
            width: "100px",
            height: "auto",
            printColorAdjust: "exact", // For accurate rendering during print
            WebkitPrintColorAdjust: "exact",
          }}
        />
        <img
          src={paid}
          alt="Paid"
          id="paidImg"
          style={{
            display: "block",
            width: "100px",
            height: "auto",
            printColorAdjust: "exact",
            WebkitPrintColorAdjust: "exact",
          }}
        />
        <img
          src={red}
          alt="Red"
          id="red"
          style={{
            display: "block",
            width: "100px",
            height: "auto",
            printColorAdjust: "exact",
            WebkitPrintColorAdjust: "exact",
          }}
        />

        <div className="invoice">
          {/* ================ Header ==================== */}
          <div class="flex space-x-4">
            <div class="flex-1 p-4 flex justify-center items-center">
              <img src={logo} alt="logo" />
            </div>
            <div class="flex-[2] p-4 text-center">
              <p>NIT: 800124570-87</p>
              <p>Email: onlinecargopioneers@gmail.com</p>
              <p>Street: 2500 Southbranch Blvd A, United States </p>
            </div>
            <div class="flex-1 p-4 flex justify-center items-center">
              <img
                src={`https://barcode.tec-it.com/barcode.ashx?data=${parcel?.trackingId}&code=Code128&multiplebarcodes=false&translate-esc=false&unit=Fit&dpi=72&imagetype=Gif&rotation=0&color=%23000000&bgcolor=%23ffffff&qunit=Mm&quiet=0&modulewidth=50`}
                alt="Barcode"
              />
            </div>
          </div>

          <hr />

          {/* ================ Billing to Address ==================== */}

          <div class="flex space-x-6 mt-10">
            <div class="flex-1 p-4 ">
              <h4 style={{ fontWeight: 500 }}>Bill to</h4>
              <h4 style={{ fontWeight: 500 }}>{parcel?.receiverFullname}</h4>
              <br />
              <p>{parcel?.deliveryAddress}</p>
              <p>{parcel?.receiverEmail}</p>
            </div>

            <div class="flex-1  ">
              <div class="overflow-x-auto">
                <table class="table-auto border-collapse border border-gray-300 w-full text-left">
                  <thead class="bg-gray-200 hidden">
                    <tr>
                      <th class="bg-gray-400 w-1/3 border border-gray-300 p-2 ">
                        Hidden
                      </th>
                      <th class=" w-2/3 border border-gray-300 p-2">
                        Column 2
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bg-gray-500 border border-gray-300 p-2 text-white">
                        Pay Mode
                      </td>
                      <td class="border border-gray-300 p-2 text-right">
                        Cash
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-gray-500 border border-gray-300 p-2 text-white">
                        Service Shipping
                      </td>
                      <td class="border border-gray-300 p-2 text-right">
                        Air Freight
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-gray-500 border border-gray-300 p-2 text-white">
                        Shipping Mode
                      </td>
                      <td class="border border-gray-300 p-2 text-right">
                        Cargopineers
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-gray-500 border border-gray-300 p-2 text-white">
                        Shipping date
                      </td>
                      <td class="border border-gray-300 p-2 text-right">
                        {moment(parcel?.shipmentDate).format("ll")}
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-gray-500 border border-gray-300 p-2 text-white">
                        Invoice No.
                      </td>
                      <td class="border border-gray-300 p-2 text-right">
                        {parcel?.trackingId}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* ================ Parcel details ==================== */}

          <div style={{ overflowX: "auto", marginTop: 40 }}>
            <table style={tableStyles}>
              <thead>
                <tr>
                  <th style={headerStyles}>Quantity</th>
                  <th style={headerStyles}>Description</th>
                  <th style={headerStyles}>Weight (kg)</th>
                  <th style={headerStyles}>Length (cm)</th>
                  <th style={headerStyles}>Width (cm)</th>
                  <th style={headerStyles}>Height (cm)</th>
                  <th style={headerStyles}>Weight (lb)</th>
                  <th style={headerStyles}>Declared value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={cellStyles}>1</td>
                  <td style={cellStyles}>{parcel?.parcelDescription}</td>
                  <td style={cellStyles}>{parcel?.parcelWeight}</td>
                  <td style={cellStyles}>
                    {parcel?.parcelDimensions.split("x")[0]}
                  </td>
                  <td style={cellStyles}>
                    {parcel?.parcelDimensions.split("x")[1]}
                  </td>
                  <td style={cellStyles}>
                    {parcel?.parcelDimensions.split("x")[2]}
                  </td>
                  <td style={cellStyles}>
                    {(Number(parcel?.parcelWeight) * 2.2046).toFixed(2)}
                  </td>
                  <td style={cellStyles}>{parcel?.parcelValue}</td>
                </tr>
                <tr>
                  <td colSpan="8" style={{ ...cellStyles, textAlign: "right" }}>
                    Price/kg: 22
                  </td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Subtotal
                  </td>
                  <td style={cellStyles}>{subTotal.toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Discount 0%
                  </td>
                  <td style={cellStyles}>0.00</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Shipping insurance 3%
                  </td>
                  <td style={cellStyles}>{insurance.toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Customs tariffs 2.1%
                  </td>
                  <td style={cellStyles}>{tariff.toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Tax 17%
                  </td>
                  <td style={cellStyles}>{tax.toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Declared tax 15%
                  </td>
                  <td style={cellStyles}>{declaredTax.toFixed(2)}</td>
                </tr>
                <tr>
                  <td colSpan="7" style={cellStyles}>
                    Re expedition
                  </td>
                  <td style={cellStyles}>0.00</td>
                </tr>
                <tr style={footerRowStyles}>
                  <td colSpan="7" style={cellStyles}>
                    COURIER FEE USD
                  </td>
                  <td style={cellStyles}>${fee.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* ================ Terms ==================== */}

          <div className="termsContainer text-center mt-6">
            <span className="text-center">TERMS</span>
            <hr className="mt-2" />
            <p className="py-6 text-left px-4">
              ACCEPTED: This Invoice is a title value in accordance with the
              provisions of art. 3 of law 1231 of July 17/08. The signature by
              third parties in representation, mandate or other quality on
              behalf of the buyer implies its obligation in accordance with art.
              640 of the commercial code.
            </p>
            <hr />
          </div>

          {/* -------- Print BTN ----------- */}
          <button
            className="m-6 bg-orange-700 p-2 text-white"
            onClick={handlePrint}
            style={{ fontSize: "16px" }}
          >
            Print Invoice &nbsp;&nbsp; <i className="fa fa-print"></i>
          </button>
        </div>
      </div>

      <style>
        {`
           @media print {
            html {
              font-size: 10px;
            }
            body {
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
            }
            .invoiceWrapper {
              padding: 20px;
              width: 100%;
              height: auto;
              page-break-inside: avoid;
            }
            .invoice {
              max-width: 100%;
            }

           #paidImg{
              display: block !important; /* Force display */
              width: 100px !important; /* Ensure size consistency */
              height: auto !important;
              print-color-adjust: exact !important;
              -webkit-print-color-adjust: exact !important;
              top: 550px;
              left: 316px;
            }


             #red {
              display: block !important; /* Force display */
              width: 100px !important; /* Ensure size consistency */
              height: auto !important;
              print-color-adjust: exact !important;
              -webkit-print-color-adjust: exact !important;
              top: 550px;
              left: 516px;
            }



            #approveImg {
              display: block !important; /* Force display */
              width: 100px !important; /* Ensure size consistency */
              height: auto !important;
              print-color-adjust: exact !important;
              -webkit-print-color-adjust: exact !important;
              top: 200px;
              left: 500px;
            }

            .print:hidden {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
};

export default Invoice;
